// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LayoutRouteRouteImport } from './routes/_layout/route'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as LayoutApplicationRequirementsRouteImport } from './routes/_layout/application-requirements'
import { Route as LayoutApplyRouteImport } from './routes/_layout/apply'
import { Route as LayoutContactRouteImport } from './routes/_layout/contact'
import { Route as LayoutFloorPlansRouteImport } from './routes/_layout/floor-plans'
import { Route as LayoutGalleryRouteImport } from './routes/_layout/gallery'
import { Route as LayoutUnitsRouteImport } from './routes/_layout/units'

const LayoutRouteRoute = LayoutRouteRouteImport.update({
            id: '/_layout',getParentRoute: () => rootRouteImport
          })
const LayoutIndexRoute = LayoutIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutRouteRoute
          })
const LayoutApplicationRequirementsRoute = LayoutApplicationRequirementsRouteImport.update({
            id: '/application-requirements',path: '/application-requirements',getParentRoute: () => LayoutRouteRoute
          })
const LayoutApplyRoute = LayoutApplyRouteImport.update({
            id: '/apply',path: '/apply',getParentRoute: () => LayoutRouteRoute
          })
const LayoutContactRoute = LayoutContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => LayoutRouteRoute
          })
const LayoutFloorPlansRoute = LayoutFloorPlansRouteImport.update({
            id: '/floor-plans',path: '/floor-plans',getParentRoute: () => LayoutRouteRoute
          })
const LayoutGalleryRoute = LayoutGalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => LayoutRouteRoute
          })
const LayoutUnitsRoute = LayoutUnitsRouteImport.update({
            id: '/units',path: '/units',getParentRoute: () => LayoutRouteRoute
          })





const LayoutRouteRouteChildren = {
  LayoutApplicationRequirementsRoute: LayoutApplicationRequirementsRoute,LayoutApplyRoute: LayoutApplyRoute,LayoutContactRoute: LayoutContactRoute,LayoutFloorPlansRoute: LayoutFloorPlansRoute,LayoutGalleryRoute: LayoutGalleryRoute,LayoutUnitsRoute: LayoutUnitsRoute,LayoutIndexRoute: LayoutIndexRoute
}

const LayoutRouteRouteWithChildren = LayoutRouteRoute._addFileChildren(LayoutRouteRouteChildren)

const rootRouteChildren = {
  LayoutRouteRoute: LayoutRouteRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)